<template>
  <div
    class="item"
    :class="{
      'no-pass': item.have_done_count > 0 && (item.pass_status == 2 || item.passed == 0),
      pass: item.have_done_count > 0 && (item.pass_status == 1 || item.passed == 1),
    }"
  >
    <div class="header">
      <span class="status process" v-if="item.start_status == 1">进行中</span>
      <span class="status" v-else-if="item.start_status == 2">未开始</span>
      <span class="status" v-else-if="item.start_status == 3">已结束</span>
      <span v-if="showName" class="name bold" :title="item.name">
        《{{ item.exam_type == 1 ? '模拟考试' : '正式考试' }}》{{ item.name }}
      </span>
    </div>
    <div class="detail">
      <div>
        <label>考试时间：</label>
        <span>
          {{ item.start_time | tsFormat('MM月dd日 hh:mm') }} ~
          {{ item.end_time | tsFormat('MM月dd日 hh:mm') }}
        </span>
      </div>
      <div>
        <label>考试时长：</label>
        <span>{{ item.limit_times }}</span>
      </div>
      <div>
        <label>满&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分：</label>
        <span>{{ parseFloat(item.score) }}分</span>
      </div>
      <div>
        <label>通过分数：</label>
        <span>{{ parseFloat(item.pass_score) }}分</span>
      </div>
      <div>
        <label>考试次数：</label>
        <span>{{ item.repeat_times }}（已考{{ item.have_done_count }}次）</span>
      </div>
    </div>
    <div class="line"></div>
    <div class="operate" v-if="item.start_status == 3">
      <router-link
        v-if="item.have_done_count > 0"
        :to="{
          name: 'ExamPackagePracticeScore',
          query: { id: item.report_id, type: 's' },
        }"
      >
        查看成绩
      </router-link>
      <router-link
        :to="{
          name: 'ExamPackagePracticeDo',
          query: { type: 's', action: 'preview', id: item.id },
        }"
      >
        查看详情
      </router-link>
    </div>
    <div class="operate" v-else-if="item.start_status == 2">
      <a @click="$info('该场考试尚未开始')">即将开始</a>
    </div>
    <div class="operate" v-else-if="item.start_status == 1">
      <router-link
        v-if="item.have_done_count == 0"
        :to="{
          name: 'ExamPackagePracticeDes',
          query: { type: 's', id: item.id },
        }"
      >
        立即考试
      </router-link>
      <router-link
        v-if="item.have_done_count > 0"
        :to="{
          name: 'ExamPackagePracticeScore',
          query: { id: item.report_id, type: 's' },
        }"
      >
        查看成绩
      </router-link>
      <router-link
        v-if="item.have_done_count > 0 && item.have_done_count < item.repeat_times"
        :to="{
          name: 'ExamPackagePracticeDes',
          query: { type: 's', id: item.id, report_id: item.report_id },
        }"
      >
        再考一次
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExamSimulationItem',
  props: {
    item: {
      type: Object,
    },
    showName: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.extend();
  },
  watch: {
    item() {
      this.extend();
    },
  },
  methods: {
    extend() {
      if (this.item.limit_time > 0) {
        let limit_times = '';
        if (this.item.limit_time > 60) {
          limit_times += parseInt(this.item.limit_time / 60) + '分钟';
        }
        if (this.item.limit_time % 60 > 0) {
          limit_times += (this.item.limit_time % 60) + '秒';
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.item.limit_times = limit_times;
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.item.limit_times = '无限制';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/varibles.scss';
.item {
  float: left;
  width: 370px;
  height: 273px;
  margin-right: 20px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 5px 5px 10px 10px;
  box-sizing: border-box;
  padding: 16px 22px;
  margin-bottom: 20px;
  &:nth-child(3n) {
    margin-right: 0;
  }
  &.no-pass {
    background-image: url(../images/exam/package/no-pass@2x.png);
    background-repeat: no-repeat;
    background-size: 52px 161px;
    background-position: 300px 22px;
  }
  &.pass {
    background-image: url(../images/exam/package/pass.png);
    background-repeat: no-repeat;
    background-size: 52px 53px;
    background-position: 300px 22px;
  }
  .header {
    display: flex;
    .name {
      font-size: 20px;
      color: #333333;
      margin-left: 11px;
      flex-grow: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .status {
      display: inline-block;
      width: 50px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      color: white;
      background-color: #999999;
      flex: 0 0 auto;
      &.process {
        background-color: #00b174;
      }
    }
  }
  .detail {
    padding-top: 16px;
    font-size: 14px;
    margin-bottom: 25px;
    > div {
      margin-bottom: 6px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    label {
      color: #8c8c8c;
    }
  }
  .line {
    height: 1px;
    background-color: #eeeeee;
  }
  .operate {
    text-align: right;
    padding-top: 16px;
    a {
      background-color: $primary-color;
      color: white;
      width: 80px;
      height: 32px;
      border-radius: 16px;
      display: inline-block;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      cursor: pointer;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
